module.exports = __webpack_public_path__ + "static/media/home-chat.5697d4ae.jpg";